// import { requestFunnel, requestFunnelCL, requestFunnelPE, requestFunnelBR } from '@/application/api';
import { requestFunnel, requestFunnelCL, requestFunnelBR, requestFunnelPE } from '@/application/api';
import { authenticationService } from '@/application/services/api-clients/login-service';

export class UsersService {
  constructor(funnel, authenticationServiceIn) {
    this.funnel = funnel;
    this.authenticationService = authenticationServiceIn;
  }

  async byId(userId) {
    const options = { headers: this.authenticationService.authHeader() };
    const response = await this.funnel.get(`users/${userId}`, options);
    return response.data;
  }

  async userNameById(userId) {
    const user = await this.byId(userId);
    return user.name;
  }
}

export const deleteUser = async user => {
  const userId = user._id;
  const options = { headers: authenticationService.authHeader() };
  await requestFunnel.delete(`user/${userId}`, options);
};

export const findUserIdsByEmailOnAllCountries = async email => {
  try {
    const options = { headers: authenticationService.authHeader() };
    const path = `user/?searchString=${email}`;
    const promises = [requestFunnelCL.get(path, options), requestFunnelPE.get(path, options), requestFunnelBR.get(path, options)];
    const result = await Promise.allSettled(promises);
    const ids = result.map(res => res.value?.data[0]?._id || '');
    return { cl: ids[0], pe: ids[1], br: ids[2] };
  } catch (_err) {
    return { cl: '', pe: '', br: '' };
  }
};

export const findBackOfficeUsers = async () => {
  const options = { headers: authenticationService.authHeader() };
  options.params = { searchString: '', nonClientUsers: 'true' };
  const response = await requestFunnel.get('user', options);
  // Filter users that do not have the allowedUserFeatures array
  // This is temporary behavior that should be removed once the
  // transition to user features has been completed
  return response.data.filter(user => user.rol !== 'CLIENT' && user.rol !== 'PROSPECT');
};

export const getAllUserFeatures = async () => {
  const options = { headers: authenticationService.authHeader() };
  const response = await requestFunnelCL.get('user/features', options);
  return response.data;
};

export const getAllUserFeatureSections = async () => {
  const options = { headers: authenticationService.authHeader() };
  const response = await requestFunnelCL.get('user/features/sections', options);
  return response.data;
};

export const createlUserFeatureSection = async sectionIn => {
  const section = JSON.parse(JSON.stringify(sectionIn));
  delete section._id;
  const body = section;
  const options = { headers: authenticationService.authHeader() };
  const response = await requestFunnelCL.post('user/features/sections', body, options);
  return response.data;
};

export const updatelUserFeatureSection = async section => {
  const sectionId = section._id;
  const body = section;
  const options = { headers: authenticationService.authHeader() };
  const response = await requestFunnelCL.patch(`user/features/sections/${sectionId}`, body, options);
  return response.data;
};

export const deleteUserFeatureSection = async section => {
  const sectionId = section._id;
  const options = { headers: authenticationService.authHeader() };
  await requestFunnelCL.delete(`user/features/sections/${sectionId}`, options);
};

export const setUserFeature = async (userId, featureName, featureStatus) => {
  if (typeof featureStatus !== 'boolean') {
    throw Error('Invalid status');
  }
  const body = { userFeatures: [{ name: featureName, status: featureStatus }] };
  const options = { headers: authenticationService.authHeader() };
  const response = await requestFunnel.patch(`user/${userId}/userFeatures`, body, options);
  return response.data;
};

// [{ name: featureName, status: featureStatus }]
export const setUserFeatures = async (userId, userFeatures) => {
  const body = { userFeatures };
  const options = { headers: authenticationService.authHeader() };
  const response = await requestFunnel.patch(`user/${userId}/userFeatures`, body, options);
  return response.data;
};
// Clona permisos de usuario en los 3 países
export const cloneUserFeatures = async (userIdsByCOuntry, userFeatures) => {
  const { cl, br, pe } = userIdsByCOuntry;
  const body = { userFeatures };
  const options = { headers: authenticationService.authHeader() };
  if (cl) await requestFunnelCL.patch(`user/${cl}/userFeatures`, body, options);
  if (pe) await requestFunnelPE.patch(`user/${pe}/userFeatures`, body, options);
  if (br) await requestFunnelBR.patch(`user/${br}/userFeatures`, body, options);
  // return responseCL.data;
};

export const activateUserFeatures = async userId => {
  const body = {};
  const options = { headers: authenticationService.authHeader() };
  const response = await requestFunnel.patch(`user/${userId}/activateUserFeatures`, body, options);
  return response.data;
};

export const updateUserState = async (email, disable, reason) => {
  const body = { email, disable, reason };
  const options = { headers: authenticationService.authHeader() };
  const response = await requestFunnel.patch('user/change-user-state', body, options);
  return response.data;
};

export const getUserState = async email => {
  const options = { headers: authenticationService.authHeader() };
  const response = await requestFunnel.get(`user/${email}/get-user-state`, options);
  return response.data;
};
